import React from "react";

export const SplashSscreen: React.FC = () => {
    return (
        <div className="flex h-[100vh] justify-center items-center">
            <img src="/lamtaakam-loading.gif" alt="loading" width="100px"/>
        </div>
    );
};